import { ProductPurchasesLookupResolveService } from './shared/services/product-purchases-lookup-resolve.service';
import { StoreService } from './shared/services/store-service.service';
import { CvDatabaseProductService } from './shared/services/cv-database-product-service.service';
import { ProductPurchasesRoutingModule } from './product-purchases-routing.module';
import { SharedModule } from '../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProductPurchasesShellComponent } from './product-purchases-shell/product-purchases-shell.component';
import { CvDatabaseProductRequestListComponent } from './cv-database-product-request-list/cv-database-product-request-list.component';
import { SliderBannerProductRequestListComponent } from './slider-banner-product-request-list/slider-banner-product-request-list.component';
import { SliderBannerProductService } from '@admin/product-purchases/shared/services/slider-banner-product.service';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmWithCheckboxComponent } from './confirm-with-checkbox/confirm-with-checkbox.component';
import { CvBoxProductRequestListComponent } from './cv-box-product-request-list/cv-box-product-request-list.component';
import { BrandingProductRequestListComponent } from './branding-product-request-list/branding-product-request-list.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ProductPurchasesRoutingModule,
    CheckboxModule,
  ],
  providers: [
    CvDatabaseProductService,
    SliderBannerProductService,
    StoreService,
    ProductPurchasesLookupResolveService,
  ],
  declarations: [
    ProductPurchasesShellComponent,
    CvDatabaseProductRequestListComponent,
    SliderBannerProductRequestListComponent,
    ConfirmWithCheckboxComponent,
    CvBoxProductRequestListComponent,
    BrandingProductRequestListComponent,
  ],
})
export class ProductPurchasesModule {}
